export function setNewSearchStickyHeight()
{
	if (($('.left.sticky').length !== 0))
	{
		if ($('#searchPageConfirmer').length !== 0 || $('#freetextSearchPageConfirmer').length !== 0)
		{
			if ($('.left.sticky').length !== 0 && !$('.left.sticky').hasClass('is-splash'))
			{
				if ($('#searchPageConfirmer').length !== 0)
				{
					matchLeftStickyHeightToIdAfterDelay('searchPageConfirmer');
				}
				else
				{
					matchLeftStickyHeightToIdAfterDelay('freetextSearchPageConfirmer');
				}
			}
		}
		else if ($('#basic-content').length !== 0)
		{
			if ($('.left.sticky').length !== 0)
			{
				matchLeftStickyHeightToIdAfterDelay('basic-content');
			}
		}
	}
}

function matchLeftStickyHeightToIdAfterDelay(id)
{
	$('.left.sticky').attr('style', 'height:' + $('#' + id).outerHeight() + 'px;');
	setTimeout(function ()
	{
		$('.left.sticky').attr('style', 'height:' + $('#' + id).outerHeight() + 'px;');
	}, 1000);
}
